






























































































































































































































import Component from 'vue-class-component';
import Vue from 'vue';
import {KtSetting} from "../interfaces";
import {State} from "../store";
import {isEmpty} from "../../plagins/utils";
import {trans} from "../../plagins/translate";

@Component({
    components: {}
})
export default class SettingsVue extends Vue {

    state: State | any;

    style: any = "";
    styles: string[] = [];

    valueComparator(a: KtSetting, b: KtSetting) {
        return a.id === b.id;
    }

    beforeOpen() {
        console.log('beforeOpen');
        if (this.state.template.styles) {

            let styles = [];
            for (let style in this.state.template.styles) {
                styles.push(style);
            }
            Vue.set(this, 'styles', styles);

            if (this.styles.length > 0) {
                Vue.set(this, 'style', styles[0]);
            }
        }
    }


    // selected_item: number | any = 0;

    selectSortColumn(item: KtSetting) {
        this.$store.commit('set_sort_by', item)
    }

    // selectDirection(item: Direction) {
    //     this.$store.commit('set_direction_for_sort', item)
    // }

    setLimit(limit: number) {
        this.$store.commit('set_paginator_limit', limit)
    }

    trans(s: string): string {
        return trans(s);
    }

    mounted(): void {

    }


    created(): void {
        this.state = this.$store.state;
    }

}
